import React, { useEffect } from 'react';
import { Control, UseFormSetValue } from 'react-hook-form';
// import { useExerciseMetaData } from '../../api';
import PositionsField from '../../forms/position-field/PositionsField';
import VesselField from '../../forms/vessel-field/VesselField';
import { StudentEnvironment } from '../../types';

export interface StudentPositionsProps {
  control: Control<any>;
  clearErrors: any;
  exerciseId?: string;
  vessel: {
    vesselCode: string | null;
    vesselName: string | null;
  } | null;
  studentEnvironment?: StudentEnvironment[];
  setValue: UseFormSetValue<any>;
}

const StudentPositions = ({
  control,
  clearErrors,
  exerciseId,
  vessel,
  studentEnvironment,
  setValue,
}: StudentPositionsProps) => {
  const studentPositions = studentEnvironment?.find(v => v.vesselName === vessel?.vesselName)?.students;

  useEffect(() => {
    if (studentEnvironment?.length === 1) {
      // default value
      setValue('vessel', {
        vesselCode: studentEnvironment[0].vesselCode,
        vesselName: studentEnvironment[0].vesselName,
      });
      clearErrors('vessel');

      if (studentEnvironment[0].students?.length === 1) {
        setValue('studentEnvironment', studentEnvironment[0].students[0]);
        clearErrors('studentEnvironment');
      }
    }
  }, [studentEnvironment]);

  useEffect(() => {
    if (vessel) {
      if (studentPositions?.length === 1) {
        setValue('studentEnvironment', studentPositions[0]);
        clearErrors('studentEnvironment');
      }
    }
  }, [vessel]);

  return (
    <>
      <VesselField
        control={control}
        loading={!!exerciseId && !studentEnvironment}
        studentEnvironment={studentEnvironment}
        name="vessel"
      />
      <PositionsField
        control={control}
        loading={!!exerciseId && !studentEnvironment}
        studentPositions={studentPositions}
        name="studentEnvironment"
      />
    </>
  );
};

export default StudentPositions;
